import Point from "../model/point";

export default class VennDiagramText {
  constructor(
    public text: string,
    public position: Point,
  ) {}
}
